import type { CtrlApiError } from "@repo/sdk";
import type { CTRL_SCHEMA } from "@repo/sdk/types";
import { useHttp, type HttpConfiguration } from "@repo/utils/hooks";
import { useCtrlClient } from "../contexts/CtrlApiProvider";

export type SettingDefinition = CTRL_SCHEMA["SettingsDefinition"];

/** Runtime setting keys the portal knows how to present. */
export const SETTING_KEYS = {
  emulatorsPerUser: "emulators.max_per_user",
  emulatorsPerTenant: "emulators.max_per_tenant",
} as const;

/** Fetch the settings key catalog: kinds, defaults, bounds and allowed scopes. */
export function useSettingDefinitions(config?: HttpConfiguration) {
  const client = useCtrlClient();

  return useHttp<SettingDefinition[], CtrlApiError>(
    client.token ? "settings" : null,
    async () => await client.listSettingDefinitions(),
    config,
  );
}
